"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2952],{

/***/ 69987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37555);







var Meta = function(_param) {
    var dismissSeoTags = _param.dismissSeoTags, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "dismissSeoTags"
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var defaultTitle = "YEMA: As\xed de f\xe1cil, as\xed de bueno";
    var title = props.title ? "".concat(props.title, " | YEMA") : defaultTitle;
    var pageUrl = ("https://yema.mx" + router.asPath).split(/[?#]/)[0];
    var canonical = props.canonicalUrl ? props.canonicalUrl : pageUrl;
    var shouldIndex = props.shouldIndex;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            shouldIndex && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "index, follow",
                name: "robots"
            }),
            shouldIndex && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "index/ follow",
                name: "googlebot"
            }),
            !dismissSeoTags && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "name",
                        itemProp: "name",
                        content: title
                    }, "name"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        itemProp: "description",
                        content: props.description
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "image",
                        itemProp: "image",
                        content: props.image
                    }, "image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: props.keywords
                    }, "keywords"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: pageUrl
                    }, "og:url"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }, "og:type"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: props.description
                    }, "og:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: defaultTitle
                    }, "og:site_name"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: props.image
                    }, "og:image"),
                    (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                        "productTags",
                        "brand"
                    ]) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "product:brand",
                        content: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                            "productTags",
                            "brand"
                        ])
                    }, "product:brand"),
                    (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                        "productTags",
                        "hasStock"
                    ]) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "product:availability",
                        content: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                            "productTags",
                            "hasStock"
                        ]) ? "in stock" : "out of stock"
                    }, "product:availability"),
                    (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                        "productTags"
                    ]) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "product:condition",
                        content: "new"
                    }, "product:condition"),
                    (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                        "productTags",
                        "price"
                    ]) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "product:price:amount",
                        content: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                            "productTags",
                            "price"
                        ])
                    }, "product:price:amount"),
                    (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                        "productTags",
                        "currency"
                    ]) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "product:price:currency",
                        content: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                            "productTags",
                            "currency"
                        ])
                    }, "product:price:currency"),
                    (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                        "productTags",
                        "id"
                    ]) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "product:retailer_item_id",
                        content: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                            "productTags",
                            "id"
                        ])
                    }, "product:retailer_item_id"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "fb:app_id",
                        content: "2504608542988597"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }, "twitter:card"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: props.description
                    }, "twitter:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@yemamx"
                    }, "twitter:site"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@yemamx"
                    }, "twitter:creator"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: props.image
                    }, "twitter:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: canonical
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "alternate",
                        href: pageUrl,
                        hrefLang: "x-default"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "alternate",
                        href: pageUrl,
                        hrefLang: "es-MX"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/ico",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                href: "/favicon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preconnect",
                href: "https://cdn.ravenjs.com",
                crossOrigin: "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preconnect",
                href: "https://us-central1-yema-cdn-dev.cloudfunctions.net"
            })
        ]
    });
};
Meta.defaultProps = {
    title: null,
    description: "YEMA: el primer s\xfaper consciente de M\xe9xico. As\xed de bueno. As\xed de f\xe1cil.",
    keywords: "productos saludables, productos org\xe1nicos, comida saludable, tienda de productos org\xe1nicos, productos naturales, productos ecol\xf3gicos, tienda de productos saludables en M\xe9xico",
    image: "",
    canonicalUrl: null,
    shouldIndex: true,
    dismissSeoTags: false
};
Meta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    keywords: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    canonicalUrl: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    shouldIndex: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    dismissSeoTags: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool
};
/* harmony default export */ __webpack_exports__["Z"] = (Meta);


/***/ }),

/***/ 20625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ doSubscribeEmailToTag; },
/* harmony export */   "q": function() { return /* binding */ doCreateOrUpdateIntercom; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37555);



/**
 * doCreateOrUpdateIntercom
 * @param email
 * @param newsletter
 * @param name
 * @param role
 * @param type
 * @returns {Promise<void>}
 */ function doCreateOrUpdateIntercom(email) {
    return _doCreateOrUpdateIntercom.apply(this, arguments);
}
function _doCreateOrUpdateIntercom() {
    _doCreateOrUpdateIntercom = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(email) {
        var newsletter, name, role, type, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    newsletter = _args.length > 1 && _args[1] !== void 0 ? _args[1] : undefined, name = _args.length > 2 && _args[2] !== void 0 ? _args[2] : "", role = _args.length > 3 && _args[3] !== void 0 ? _args[3] : "lead", type = _args.length > 4 && _args[4] !== void 0 ? _args[4] : "";
                    _ctx.next = 3;
                    return fetch("".concat("https://yema.mx", "/api/intercom/create-or-update"), {
                        method: "post",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        body: (0,sf_modules__WEBPACK_IMPORTED_MODULE_1__/* .stringify */ .Pz)({
                            email: email,
                            name: name,
                            role: role,
                            newsletter: newsletter
                        })
                    });
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _doCreateOrUpdateIntercom.apply(this, arguments);
}
function doSubscribeEmailToTag(email, tagId) {
    return _doSubscribeEmailToTag.apply(this, arguments);
} /**
 * Unsubscribe user or lead (Remove newsletter tag)
 */  // export async function doUnsubscribeFromNewsletterIntercom(email) {
 //     await fetch(`${process.env.NEXT_PUBLIC_URL}/crm/detach`, {
 //         method: 'post',
 //         headers: {
 //             'Accept': 'application/json',
 //             'Content-Type': 'application/json',
 //         },
 //         body: stringify({
 //             email: email,
 //         })
 //     });
 // }
function _doSubscribeEmailToTag() {
    _doSubscribeEmailToTag = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(email, tagId) {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return fetch("".concat("https://yema.mx", "/api/intercom/subscribe-to-tag"), {
                        method: "post",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        body: (0,sf_modules__WEBPACK_IMPORTED_MODULE_1__/* .stringify */ .Pz)({
                            email: email,
                            tagId: tagId
                        })
                    }).then(function(res) {
                        return res.json();
                    }).then(function(res) {
                        return res;
                    });
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _doSubscribeEmailToTag.apply(this, arguments);
}


/***/ }),

/***/ 2952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Page_layout; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/commerce/src/StoreClient.ts
var StoreClient = __webpack_require__(52177);
// EXTERNAL MODULE: ../../packages/commerce/src/APIClient.ts + 1 modules
var APIClient = __webpack_require__(33125);
// EXTERNAL MODULE: ../../packages/commerce/src/CommerceProvider.tsx + 15 modules
var CommerceProvider = __webpack_require__(82148);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../packages/commerce/src/store/actions/cartActions.js
var cartActions = __webpack_require__(43931);
// EXTERNAL MODULE: ../../packages/commerce/src/index.ts + 2 modules
var commerce_src = __webpack_require__(25144);
// EXTERNAL MODULE: ../../packages/commerce/src/hooks/tracking/useTracker.ts
var useTracker = __webpack_require__(69590);
// EXTERNAL MODULE: ../../packages/commerce/src/lib/apollo.js + 13 modules
var apollo = __webpack_require__(67027);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(60138);
;// CONCATENATED MODULE: ../../packages/commerce/src/graphql/queries/cms/config-pages.gql.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ConfigPages($slug: String, $first: Int) {\n        configPages(slug: $slug, first: $first) {\n            edges {\n                node {\n                    slug\n                    body\n                }\n            }\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CONFIG_PAGES_QUERY = (0,lib/* gql */.Ps)(_templateObject());
/* harmony default export */ var config_pages_gql = (CONFIG_PAGES_QUERY);

// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(67546);
;// CONCATENATED MODULE: ./functions/fnRequestAPIs/fnHeaderPromo.js






var client = (0,apollo/* initializeApollo */["in"])();
function getHeaderPromo() {
    return _getHeaderPromo.apply(this, arguments);
}
function _getHeaderPromo() {
    _getHeaderPromo = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responseConfigPage, parseConfigProductPage;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return client.query({
                        query: config_pages_gql,
                        context: {
                            clientName: "cms_api",
                            timeout: constants/* APOLLO_GRAPHQL_TIMEOUT */.Tx
                        },
                        variables: {
                            first: 1,
                            slug: "config-product-page"
                        },
                        fetchPolicy: "no-cache"
                    });
                case 2:
                    responseConfigPage = _ctx.sent;
                    parseConfigProductPage = JSON.parse((0,src/* get_ */.jR)(responseConfigPage, [
                        "data",
                        "configPages",
                        "edges",
                        0,
                        "node",
                        "body"
                    ], []));
                    return _ctx.abrupt("return", parseConfigProductPage.filter(function(x) {
                        return x.type === "promo_header";
                    }).map(function(x) {
                        return x.value;
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getHeaderPromo.apply(this, arguments);
}

// EXTERNAL MODULE: ./functions/fnRequestAPIs/fnIntercom.js
var fnIntercom = __webpack_require__(20625);
// EXTERNAL MODULE: ./components/Meta.js
var Meta = __webpack_require__(69987);
// EXTERNAL MODULE: ./constants/paths.js
var paths = __webpack_require__(69514);
// EXTERNAL MODULE: ../../packages/commerce/src/graphql/queries/checkout/checkout-for-add-to-cart.gql.js
var checkout_for_add_to_cart_gql = __webpack_require__(33303);
// EXTERNAL MODULE: ../../packages/commerce/src/graphql/queries/user/me.gql.js
var me_gql = __webpack_require__(64434);
;// CONCATENATED MODULE: ./layouts/Page.layout.js



























var YDSHeader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9097), __webpack_require__.e(6577), __webpack_require__.e(1607), __webpack_require__.e(7003), __webpack_require__.e(7346), __webpack_require__.e(3613), __webpack_require__.e(122)]).then(__webpack_require__.bind(__webpack_require__, 99435));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99435)
            ];
        }
    }
});
var HeaderBlog = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9097), __webpack_require__.e(5539)]).then(__webpack_require__.bind(__webpack_require__, 5539));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5539)
            ];
        }
    }
});
var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9097), __webpack_require__.e(7529), __webpack_require__.e(1026), __webpack_require__.e(9695), __webpack_require__.e(2681)]).then(__webpack_require__.bind(__webpack_require__, 60237));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60237)
            ];
        }
    },
    ssr: false
});
var Maintenance = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2932).then(__webpack_require__.bind(__webpack_require__, 42932));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42932)
            ];
        }
    },
    ssr: false
});
var PageLayout = function(_param) {
    var staticContent = _param.staticContent, currentCategory = _param.currentCategory, header = _param.header, fullHeader = _param.fullHeader, darkHeader = _param.darkHeader, withHeaderSubMenu = _param.withHeaderSubMenu, footer = _param.footer, footerType = _param.footerType, children = _param.children, className = _param.className, animatePresence = _param.animatePresence, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "staticContent",
        "currentCategory",
        "header",
        "fullHeader",
        "darkHeader",
        "withHeaderSubMenu",
        "footer",
        "footerType",
        "children",
        "className",
        "animatePresence"
    ]);
    var router = (0,next_router.useRouter)();
    var dispatch = (0,StoreClient/* useDispatch */.I)();
    var trackEvent = (0,useTracker/* default */.Z)().trackEvent;
    var auth = (0,StoreClient/* useSelector */.v)(function(param) {
        var authentication = param.authentication;
        return authentication;
    });
    var checkoutBase64Id = (0,StoreClient/* useSelector */.v)(function(param) {
        var cart = param.cart;
        return cart.checkoutID;
    });
    var checkoutToken = (0,src/* decodeIdBase64 */.D1)(checkoutBase64Id);
    var ref = (0,_sliced_to_array/* default */.Z)((0,commerce_src/* useStateEngine */.kG)(), 2), _ = ref[0], dispatchStateEngine = ref[1];
    /** Checkout query: required to update apollo cache */ var ref1 = (0,APIClient/* useQuery */.aM)(checkout_for_add_to_cart_gql/* default */.Z, {
        variables: {
            token: checkoutToken
        },
        ssr: checkoutToken,
        skip: !checkoutToken
    }), loading = ref1.loading, error = ref1.error, data = ref1.data;
    var ref2 = (0,APIClient/* useQuery */.aM)(me_gql/* default */.Z, {
        variables: {},
        ssr: false,
        fetchPolicy: "cache-first",
        skip: !auth || !auth.token || router.asPath !== "/?soy-nuevo-cliente"
    }), userData = ref2.data;
    var ref3 = (0,react.useState)(null), promoHeader = ref3[0], setPromoHeader = ref3[1];
    var ref4 = (0,react.useState)(null), userConfigPage = ref4[0], setUserConfigPage = ref4[1];
    var parsePromoHeader = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var promo, promoHeaderData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getHeaderPromo();
                    case 2:
                        promo = _ctx.sent;
                        promoHeaderData = (0,src/* get_ */.jR)(promo, [
                            0,
                            "published"
                        ], false) ? (0,src/* get_ */.jR)(promo, [
                            0
                        ]) : false;
                        setPromoHeader(promoHeaderData);
                        return _ctx.abrupt("return", promoHeaderData);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function parsePromoHeader() {
            return _ref.apply(this, arguments);
        };
    }();
    var subscribeNewsletter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(value) {
            var validateEmail;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(value && value !== "")) {
                            _ctx.next = 14;
                            break;
                        }
                        validateEmail = new RegExp(constants/* EMAIL_REGEX */.CU).test(value);
                        if (validateEmail) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return", false);
                    case 4:
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return (0,fnIntercom/* doCreateOrUpdateIntercom */.q)(value, true, "", "lead", "Footer");
                    case 7:
                        trackEvent({
                            type: "Newsletter Subscription",
                            data: {
                                category: "Account",
                                label: "Footer",
                                type: "Footer"
                            }
                        });
                        return _ctx.abrupt("return", true);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](4);
                        return _ctx.abrupt("return", false);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    11
                ]
            ]);
        }));
        return function subscribeNewsletter(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClosePromoHeader = function(key) {
        src/* sessionstorage.set */.zN.set(constants/* PROMO_HEADER */.DT, key, true);
        setUserConfigPage(key);
        dispatchStateEngine({
            type: CommerceProvider/* APP_STATE_TYPES.CONFIG_SET */.ro.CONFIG_SET,
            config: {
                promoHeader: {
                    visible: false
                }
            }
        });
    };
    (0,react.useEffect)(function() {
        var isCancelled = false;
        if (!loading && !data && error) {
            if (isCancelled) return;
            // Invalidate checkout cookie if checkout ID expired
            dispatch((0,cartActions/* checkout_reset */.qL)());
        }
        return function() {
            isCancelled = true;
        };
    }, [
        loading,
        error,
        data
    ]);
    (0,react.useEffect)(function() {
        var scrollToAnchorTimer;
        var isCancelled = false;
        parsePromoHeader().then(function(promoHeaderData) {
            if (isCancelled) return;
            var getPromoHeader = src/* sessionstorage.get */.zN.get(constants/* PROMO_HEADER */.DT, true);
            dispatchStateEngine({
                type: CommerceProvider/* APP_STATE_TYPES.CONFIG_SET */.ro.CONFIG_SET,
                config: {
                    promoHeader: {
                        visible: promoHeaderData && (getPromoHeader === null || getPromoHeader !== (0,src/* slugify */.lV)(promoHeaderData.text))
                    }
                }
            });
            setUserConfigPage(getPromoHeader);
            var offset = promoHeaderData && (getPromoHeader === null || getPromoHeader !== (0,src/* slugify */.lV)(promoHeaderData.text)) ? -150 // with promo header
             : -120; // without promo header
            scrollToAnchorTimer = setTimeout(function() {
                var anchorIndex = router.asPath.indexOf("#");
                if (anchorIndex !== -1) {
                    var anchor = router.asPath.substring(anchorIndex + 1);
                    modules/* scroller.scrollTo */.OK.scrollTo(anchor, {
                        isDynamic: true,
                        duration: 600,
                        delay: 100,
                        smooth: true,
                        offset: offset
                    });
                }
            }, 2000);
        });
        return function() {
            isCancelled = true;
            clearTimeout(scrollToAnchorTimer);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (auth.token && router.asPath === "/?soy-nuevo-cliente" && userData) {
            dispatchStateEngine({
                type: CommerceProvider/* APP_STATE_TYPES.TOGGLE_MODAL */.ro.TOGGLE_MODAL,
                kind: CommerceProvider/* MODAL_KIND.SIGNUP_SUCCESS */.jk.SIGNUP_SUCCESS,
                open: true,
                props: {
                    name: auth.firstName,
                    referral: (0,src/* get_ */.jR)(userData, [
                        "me",
                        "referralCode"
                    ], {})
                }
            });
            router.push("/", {
                shallow: true
            });
        }
    }, [
        auth,
        userData
    ]);
    if (staticContent && staticContent.withError) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Maintenance, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: className
            }, otherProps), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default */.Z, (0,_object_spread/* default */.Z)({}, staticContent.metaTags)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex min-h-screen flex-col",
                        children: [
                            darkHeader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBlog, {
                                blogUrl: "/blog",
                                storeUrl: "https://yema.mx"
                            }) : header && /*#__PURE__*/ (0,jsx_runtime.jsx)(YDSHeader, {
                                fullHeader: fullHeader,
                                userLoggedIn: !!auth.token,
                                username: auth.firstName,
                                submenu: withHeaderSubMenu ? (0,src/* get_ */.jR)(staticContent, [
                                    "pageNavigations",
                                    "menuCategories"
                                ], []) : [],
                                currentCategory: currentCategory,
                                checkoutBase64Id: checkoutBase64Id,
                                userConfigPage: userConfigPage,
                                promoHeader: promoHeader,
                                handleClosePromoHeader: handleClosePromoHeader
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                style: {
                                    flex: "1 0 auto"
                                },
                                className: "flex flex-col",
                                children: children
                            }),
                            footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                                style: {
                                    flexShrink: 0
                                },
                                className: "",
                                type: footerType,
                                navigation: (0,src/* get_ */.jR)(staticContent, [
                                    "pageNavigations",
                                    "footerMenu"
                                ], []),
                                facebookUrl: paths/* YEMA_FACEBOOK */.hL,
                                instagramUrl: paths/* YEMA_INSTAGRAM */.Yk,
                                twitterUrl: paths/* YEMA_TWITTER */.qq,
                                whatsappUrl: paths/* YEMA_WHATSAPP */.Y1,
                                newsletterCallback: subscribeNewsletter
                            })
                        ]
                    })
                ]
            })),
            staticContent.preview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("fixed bottom-0 flex w-full justify-center gap-6 bg-brand-primary-500 px-6 py-2 font-body", "z-[9999] text-[12px]", {
                    "mb-[34px]": auth.isStaff
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Preview mode: "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/api/preview/end",
                        children: "Exit preview mode"
                    })
                ]
            }),
            auth.isStaff && auth.email.endsWith("@yema.mx") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("fixed bottom-0 w-full bg-ui-error py-6 pl-6 pr-24 text-center font-body text-ui-white md:pr-6", "z-[9999] text-[12px]"),
                children: "Est\xe1s conectad@ con tu cuenta STAFF POS YEMA. Se recomienda no mezclar cuentas porque puede causar errores."
            })
        ]
    });
};
PageLayout.defaultProps = {
    className: "page",
    currentCategory: {},
    staticContent: {},
    header: true,
    fullHeader: true,
    withHeaderSubMenu: true,
    footer: true,
    footerType: "full",
    darkHeader: false,
    animatePresence: false
};
PageLayout.propTypes = {
    className: prop_types.string,
    currentCategory: prop_types.object,
    staticContent: prop_types.object,
    header: prop_types.bool,
    withHeaderSubMenu: prop_types.bool,
    footer: prop_types.bool,
    footerType: prop_types.string,
    fullHeader: prop_types.bool,
    darkHeader: prop_types.bool,
    animatePresence: prop_types.bool
};
/* harmony default export */ var Page_layout = (PageLayout);


/***/ }),

/***/ 33303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60138);
/* harmony import */ var _fragments_checkout_CheckoutBasicFields_gql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49768);
/* harmony import */ var _fragments_checkout_CheckoutPricingFields_gql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48866);
/* harmony import */ var _fragments_checkout_LinesBasicFields_gql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63676);
/* harmony import */ var _fragments_checkout_LinesForAnalyticsFields_gql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60696);
/* harmony import */ var _fragments_checkout_LinesExtendedFields_gql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38185);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    query CheckoutForAddToCart(\n        $token: UUID\n        $withPricingFields: Boolean = false\n        $withLinesExtendedFields: Boolean = false\n    ) {\n        checkout(token: $token) {\n            ...CheckoutBasicFields\n            ...CheckoutPricingFields @include(if: $withPricingFields)\n            lines {\n                ...LinesBasicFields\n                ...LinesForAnalyticsFields @skip(if: $withLinesExtendedFields)\n                ...LinesExtendedFields @include(if: $withLinesExtendedFields)\n            }\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var CHECKOUT_FOR_ADD_TO_CART_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_6__/* .gql */ .Ps)(_templateObject(), _fragments_checkout_CheckoutBasicFields_gql__WEBPACK_IMPORTED_MODULE_1__/* .CheckoutBasicFieldsFragment */ .a, _fragments_checkout_CheckoutPricingFields_gql__WEBPACK_IMPORTED_MODULE_2__/* .CheckoutPricingFieldsFragment */ .c, _fragments_checkout_LinesBasicFields_gql__WEBPACK_IMPORTED_MODULE_3__/* .LinesBasicFieldsFragment */ .H, _fragments_checkout_LinesForAnalyticsFields_gql__WEBPACK_IMPORTED_MODULE_4__/* .LinesForAnalyticsFieldsFragment */ .p, _fragments_checkout_LinesExtendedFields_gql__WEBPACK_IMPORTED_MODULE_5__/* .LinesExtendedFieldsFragment */ .x);
/* harmony default export */ __webpack_exports__["Z"] = (CHECKOUT_FOR_ADD_TO_CART_QUERY);


/***/ }),

/***/ 64434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query Me {\n        me {\n            id\n            email\n            firstName\n            lastName\n            newsletter\n            referralCodeUsage\n            dateJoined\n            referralCode {\n                conditionMessage\n                code\n                discountType\n                referralDiscountMessage\n                referralProgramTitle\n                referredDiscountMessage\n            }\n            orders(first: 1) {\n                totalCount\n                edges {\n                    node {\n                        id\n                        token\n                        publicId\n                        created\n                        status\n                        statusDisplay\n                    }\n                }\n            }\n            referrals(first: 1) {\n                totalCount\n            }\n            rfcs {\n                id\n                rfc\n                businessName\n            }\n            preferredContactChannel\n            preferredContactChannelDisplay\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ME_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (ME_QUERY);


/***/ })

}]);